import { useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { IncidentDetailPatients } from 'sections/niigata/features/IncidentDetail/useIncidentDetailForNiigata';

type Args = {
  /** 傷病者情報。 */
  patientInfo: IncidentDetailPatients;
};

/** 選択した傷病者のカスタムフック。 */
export const useSelectedPatient = ({ patientInfo }: Args) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { patientId } = useParams();
  const [selectedPatient, setSelectedPatient] = useState(
    patientInfo.find(p => p.id === patientId) || patientInfo[0]
  );

  const patientNameList = patientInfo.map(({ id, baseInfo }) => ({
    patientId: id,
    patientName: baseInfo.name,
  }));

  const selectPatient = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = event.target.value;
    const patient = patientInfo.find(p => p.id === selectedId);
    if (patient) {
      setSelectedPatient(patient);

      // 現在のURLパラメータを取得
      const params = new URLSearchParams(location.search);
      const selectedDate = params.get('selected-date');
      const searchQuery = params.get('search');
      const page = params.get('page');

      // 新しいURLパラメータを構築
      const queryParams = new URLSearchParams();
      if (selectedDate) queryParams.set('selected-date', selectedDate);
      if (searchQuery) queryParams.set('search', searchQuery);
      if (page) queryParams.set('page', page);

      const queryString = queryParams.toString();
      const detailUrl = `/jian-detail/${patient.incidentId}/${selectedId}`;
      const fullUrl = `${detailUrl}${queryString ? `?${queryString}` : ''}`;

      navigate(fullUrl);
    }
  };

  return { selectedPatient, patientNameList, selectPatient };
};
